import type { CustomCellRendererProps } from "ag-grid-react";
import { clsx } from "clsx";
import { TruncateText } from "widgets";

import style from "../styles/Cell.module.css";
import { extractValueAsArray } from "../utils/tables.ts";
import { TruncateListText } from "./TruncateListText.tsx";

export const DefaultCell = (props: CustomCellRendererProps) => {
  // flat() handles nested lists as well, and has no effect on simple arrays
  const values = extractValueAsArray(props.value);
  const items = values
    .flat()
    .filter((v) => v != null)
    .map((v) => String(v));
  const listString = items.join(", ");

  if (items.length === 1) {
    const text = items[0] ?? "";

    return (
      <div className={clsx(style.cell, style.truncate_container)}>
        <span className={style.truncate_autosize} aria-hidden>{text}</span>
        <TruncateText text={text} className={style.truncate_content} />
      </div>
    );
  }

  return (
    <div className={clsx(style.cell, style.truncate_container)}>
      <span className={style.truncate_autosize} aria-hidden>{listString}</span>
      <TruncateListText items={items} className={style.truncate_content} />
    </div>
  );
};
